import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Provider, connect } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import { ApolloProvider } from 'react-apollo';
import { IntlProvider } from 'react-intl';
import { ApolloProvider as ApolloProviderWithHooks } from '@apollo/react-hooks';
import moment from 'moment-timezone';
import { Growl } from 'primereact/growl';

import { NotificationContext } from './GrowlNotifications';
import { i18nShape } from './prop-types';
import IndexWrapper from '../pages/IndexWrapper';
import { APP_BASENAME } from '../config';


import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import '../layout/theme-gr8pi-legacy.css'

import 'react-accessible-accordion/dist/fancy-example.css';
import 'react-widgets/dist/css/react-widgets.css';
import 'rc-slider/assets/index.css';
import 'react-toggle/style.css';
import 'react-tagsinput/react-tagsinput.css';
import 'cropperjs/dist/cropper.css';
import 'react-table/react-table.css';
import '../layout/layout.scss';

const mapStateToProps = (state) => {
  const { i18n } = state;
  return {
    i18n,
  };
};

class App extends Component {
  constructor(props) {
    super(props);

    this.show = this.show.bind(this);
    this.showAnyGraphQlErrors = this.showAnyGraphQlErrors.bind(this);
  }

  show(message) {
    if (this.growl) {
      this.growl.show(message);
    } else {
      console.warn(message);
    }
  }

  /**
   * Use this when you have to display graphql errors.
   * @param {*} errors
   */
  showAnyGraphQlErrors(errors, {
    severity = 'error', summary, closeable, sticky, life,
  }) {
    if (errors) {
      errors.forEach((error) => {
        this.show({
          severity,
          detail: error.message,
          summary,
          closeable,
          sticky,
          life,
        });
      });
    }
  }

  render() {
    const {
      store, client, i18n,
    } = this.props;

    const timeZone = moment.tz.guess();
    moment.tz.setDefault(timeZone);

    return (
      <React.Fragment>
        <Growl
          ref={(el) => {
            this.growl = el;
            return el;
          }}
        />
        <NotificationContext.Provider value={this}>
          <Provider store={store}>
            <ApolloProvider client={client}>
              <ApolloProviderWithHooks client={client}>
                <IntlProvider locale={i18n.locale} messages={i18n.messages} timeZone={timeZone}>
                  <Router key="mainRouter" basename={APP_BASENAME}>
                    <IndexWrapper />
                  </Router>
                </IntlProvider>
              </ApolloProviderWithHooks>
            </ApolloProvider>
          </Provider>
        </NotificationContext.Provider>
      </React.Fragment>
    );
  }
}

App.propTypes = {
  store: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.object.isRequired]).isRequired,
  client: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.object.isRequired]).isRequired,
  i18n: i18nShape.isRequired,
};

export default connect(mapStateToProps)(App);
